import React from "react";
import { SRLWrapper } from "simple-react-lightbox";

export const TourismBoards = () => {
  let pictures = [];
  for (let i = 1; i <= 13; i++) {
    pictures.push(
      require(`../../../Assets/img/photos/commissions/tourism-boards/tourism-boards-${i}.jpg`)
    );
  }
  return (
    <div className="commissions-content">
      <p className="commissions-description">
        I have worked with several tourism boards from around the world in my
        years as a photographer. They include :
        <br />
        <br />
        Indonesia Tourism Board
        <br />
        <br />
        South Tyrol Tourism Board, Italy
        <br />
        <br />
        Graubunden Tourism Board, Switzerland
        <br />
        <br />
        Grindelwald Tourism Board, Switzerland
        <br />
        <br />
        Malaysia Tourism Board
        <br />
        <br />
        Taiwan Tourism Board
        <br />
        <br />
        Western Australia Tourism Board
        <br />
        <br />
        New Zealand Tourism Board
        <br />
        <br />
        It was an honor, taking pictures for these countries, and capturing the
        beauty of their heritage - natural and historical.
      </p>
      <SRLWrapper>
        <div className="portfolio-pictures-row-portrait">
          {pictures.map((picture, index) => {
            return <img key={`tourism-boards-${index}`} src={picture} />;
          })}
        </div>
      </SRLWrapper>
    </div>
  );
};

export default TourismBoards;
